import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const uMUserWeightsApi = createApi({
  reducerPath: 'uMUserWeightsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['UserWeights'],
  endpoints: builder => ({
    getUserWeights: builder.query({
      query: params => ({
        url: '/users/user_weights/list/',
        method: 'GET',
        params
      }),
      providesTags: ['UserWeights']
    }),

    createUserWeight: builder.mutation({
      query: body => ({
        url: '/users/user_weights/',
        method: 'POST',
        body
      }),
      invalidatesTags: ['UserWeights']
    }),

    getUserWeightById: builder.query({
      query: id => ({
        url: `/users/user_weights/${id}/`,
        method: 'GET'
      }),
      providesTags: (result, error, id) => [{ type: 'UserWeights', id }]
    }),

    updateUserWeight: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/users/user_weights/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['UserWeights']
    }),

    patchUserWeight: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/users/user_weights/${id}/`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: ['UserWeights']
    })
  })
})

export const {
  useGetUserWeightsQuery,
  useCreateUserWeightMutation,
  useGetUserWeightByIdQuery,
  useUpdateUserWeightMutation,
  usePatchUserWeightMutation
} = uMUserWeightsApi
